var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 17.7226 0 19.5838 0.489435 21.0902C1.47861 24.1345 3.86545 26.5214 6.90983 27.5106C8.41616 28 10.2774 28 14 28V28C17.7226 28 19.5838 28 21.0902 27.5106C24.1346 26.5214 26.5214 24.1345 27.5106 21.0902C28 19.5838 28 17.7226 28 14V14C28 10.2774 28 8.41616 27.5106 6.90983C26.5214 3.86545 24.1346 1.47861 21.0902 0.489435C19.5838 4.76837e-07 17.7226 4.76837e-07 14 4.76837e-07V4.76837e-07C10.2774 4.76837e-07 8.41616 4.76837e-07 6.90983 0.489435C3.86545 1.47861 1.47861 3.86545 0.489435 6.90983C0 8.41616 0 10.2774 0 14V14Z",
    fill: "url(#paint0_radial_1_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.700001C10.223 0.700001 8.50045 0.708637 7.12614 1.15517C4.29487 2.07511 2.07511 4.29487 1.15517 7.12614C0.708636 8.50045 0.7 10.223 0.7 14C0.7 17.777 0.708636 19.4996 1.15517 20.8739C2.07511 23.7051 4.29487 25.9249 7.12614 26.8448C8.50045 27.2914 10.223 27.3 14 27.3C17.777 27.3 19.4996 27.2914 20.8739 26.8448C23.7051 25.9249 25.9249 23.7051 26.8448 20.8739C27.2914 19.4996 27.3 17.777 27.3 14C27.3 10.223 27.2914 8.50045 26.8448 7.12614C25.9249 4.29487 23.7051 2.07511 20.8739 1.15517C19.4996 0.708637 17.777 0.700001 14 0.700001Z",
    stroke: "#6A71C7",
    strokeOpacity: 0.84,
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1192 10.5631H18.7438C19.6547 10.5631 20.4 11.3008 20.4 12.2026V18.7605C20.4 19.6622 19.6547 20.4 18.7438 20.4H12.1192C11.2083 20.4 10.463 19.6622 10.463 18.7605V12.2026C10.463 11.3008 11.2083 10.5631 12.1192 10.5631V10.5631ZM9.25627 7.60036H15.8808C16.7917 7.60036 17.537 8.33814 17.537 9.23988V9.91956H12.1192C10.8507 9.91956 9.81285 10.9468 9.81285 12.2027V17.4369H9.25619C8.34528 17.4369 7.6 16.6992 7.6 15.7974V9.23952C7.6 8.33778 8.34528 7.6 9.25619 7.6L9.25627 7.60036Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 36.8667) rotate(-90) scale(56.4667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D69CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342A6F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendbutton);
export default __webpack_public_path__ + "static/media/Sendbutton.5cf1d6f8b6a3b1b50baab9d3a48875bd.svg";
export { ForwardRef as ReactComponent };